import { type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../styles.constants';

export const page: CSSProperties = {
  height: '100%',
};

export const row: CSSProperties = {
  flex: 1,
};

export const scrollContainer: CSSProperties = {
  flex: 1,
  overflowY: 'auto',
  height: '100%',
  position: 'relative',
};

export const scrollable: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

export const mobile: CSSProperties = {
  position: 'relative',
  flex: 1,
};

export const menuToggle: CSSProperties = {
  height: 34,
  width: 34,
  color: StyleConstants.GREY_COLOR,
  position: 'absolute',
  top: 24,
  left: 8,
  cursor: 'pointer',
};
